class TdPriceRange extends HTMLElement {
    constructor() {
        super();
       
        this.rangeLowerBound = this.querySelector('.price-range__range-group input:first-child');
        this.rangeHigherBound = this.querySelector('.price-range__range-group input:last-child');
        this.textInputLowerBound = this.querySelector('.price-range__input:first-child input');
        this.textInputHigherBound = this.querySelector('.price-range__input:last-child input'); 
        if (this.textInputLowerBound) {
            this.textInputLowerBound.addEventListener('focus', function () {
                if (this.textInputLowerBound) {
                    this.textInputLowerBound.select();
                }                
            });
            this.textInputLowerBound.addEventListener('change', this.textInputLowerUpdate.bind(this))
        }
        if (this.textInputHigherBound) {
              this.textInputHigherBound.addEventListener('focus', function () {
                if (this.textInputHigherBound) {
                     this.textInputHigherBound.select();
                }           
          });
          this.textInputHigherBound.addEventListener('change', this.textInputHigherUpdate.bind(this))
        }  
        if(this.rangeLowerBound){
            this.rangeLowerBound.addEventListener('change', this.rangeLowerBoundUpdate.bind(this))
            this.rangeLowerBound.addEventListener('input', this.rangeLowerSliderBind.bind(this))
        }   
        if(this.rangeHigherBound){
            this.rangeHigherBound.addEventListener('change', this.rangeHigherBoundUpdate.bind(this))
            this.rangeHigherBound.addEventListener('input', this.rangeHigherSliderBind.bind(this))
        }        
        
    }

    textInputLowerUpdate(event) {
        event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
        if (this.rangeLowerBound) {
            this.rangeLowerBound.value = event.target.value;
        this.rangeLowerBound.parentElement.style.setProperty('--range-min', "".concat(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max) * 100, "%"));
        }        
    }

    textInputHigherUpdate(event) {
        event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
        if(this.rangeHigherBound){
            this.rangeHigherBound.value = event.target.value;
            this.rangeHigherBound.parentElement.style.setProperty('--range-max', "".concat(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max) * 100, "%"));
        }        
    }

    rangeLowerBoundUpdate(event) {
        if (this.textInputLowerBound) {
            this.textInputLowerBound.value = event.target.value;
            this.textInputLowerBound.dispatchEvent(new Event('change', {
              bubbles: true
            }));
        }      
    }
    rangeHigherBoundUpdate(event) {
        this.textInputHigherBound.value = event.target.value;

        this.textInputHigherBound.dispatchEvent(new Event('change', {
          bubbles: true
        }));
    }
    rangeLowerSliderBind(event) {
        this.dispatchEvent(new CustomEvent('collection:abort-loading', {
            bubbles: true
          }));
          if(this.textInputHigherBound && this.textInputLowerBound) {
            event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1); // Bound the value

            event.target.parentElement.style.setProperty('--range-min', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
            this.textInputLowerBound.value = event.target.value;
          }
         
    }
    rangeHigherSliderBind(event) {
        this.dispatchEvent(new CustomEvent('collection:abort-loading', {
            bubbles: true
          }));
        if(this.textInputLowerBound && this.textInputHigherBound){
            event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1); // Bound the value

            event.target.parentElement.style.setProperty('--range-max', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
            this.textInputHigherBound.value = event.target.value;
        }    
    }
   
} 
customElements.define('td-price-range', TdPriceRange);